// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as PlaceOrderContext from "../../context/PlaceOrderContext.bs.js";
import * as PlaceOrderAssetsManager from "../../assets/PlaceOrderAssetsManager.bs.js";

var vehicleImg = PlaceOrderAssetsManager.getImage("vehicle.svg");

function RestrictedVehicleCardCmp(Props) {
  var displayName = Props.displayName;
  var vehicleImgs = Props.vehicleImgs;
  var vehicleCapacityDetails = Props.vehicleCapacityDetails;
  var match = PlaceOrderContext.useContext(undefined);
  var dispatch = match.dispatch;
  return React.createElement("div", {
              className: "vehicle-card__container restricted",
              onClick: (function (param) {
                  return Curry._1(dispatch, {
                              TAG: /* OpenSnackbar */8,
                              snackbar_message: {
                                TAG: /* Error */1,
                                _0: "Vehicle:" + displayName + " is Restricted for this location"
                              }
                            });
                })
            }, React.createElement("div", {
                  className: "sub-section"
                }, React.createElement("div", {
                      className: "title"
                    }, displayName)), React.createElement("div", {
                  className: "sub-section"
                }, React.createElement("img", {
                      className: "vehicle_img",
                      alt: "Vehicle",
                      src: vehicleImgs.deselected
                    }), React.createElement("div", {
                      className: "title"
                    }, "-")), React.createElement("div", {
                  className: "sub-section"
                }, React.createElement("div", {
                      className: "label"
                    }, "Not Available"), React.createElement("div", {
                      className: "label"
                    }, "-")), React.createElement("div", {
                  className: "sub-section capacity-details"
                }, Belt_Array.map(vehicleCapacityDetails, (function (capacityDetails) {
                        return React.createElement("div", {
                                    key: capacityDetails.key,
                                    className: "label"
                                  }, capacityDetails.value);
                      }))));
}

var make = RestrictedVehicleCardCmp;

export {
  vehicleImg ,
  make ,
  
}
/* vehicleImg Not a pure module */
